import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import moment from "moment";
  import { useHistory } from "react-router-dom";

import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner";
import { useTranslation } from "react-i18next";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import Tooltip from "@material-ui/core/Tooltip";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const {t} = useTranslation();
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function StartInspectioModal({
  onClose,
  templates,
  data,
  users,
  handlePackage
}) {
  const {t} = useTranslation();
  const [open, setOpen] = React.useState(true);
  let history = useHistory();
  let company = useSelector((state) => state.companyReducer.company);
  const handleClose = () => {
    onClose();
  };

  const [packageDetails, setPackageDetails] = React.useState(null);

  React.useEffect(() => {
   getPackageDetails()
  }, []);

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  async function createInspection({ id, schedule_id }) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let inspection_obj = {
      schedule_id,
      template_id: id,
      user_id: data.user_id,
      company_id: company.id,
      created_by: data.user_id,
    };

   

    if (packageDetails.inspection_request_status === "Request is Valid") {
      fetch(GlobalApi + "/Inspection/create_inspection", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(inspection_obj),
      })
        .then((response) => response.json())
        .then(async (res1) => {
          console.log(res1);
          fetch(GlobalApi + "/InspectionShare/create_inspection_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              inspection_id: res1.data.id,
              user_id: data.user_id,
              created_by: data.user_id,
              role: "Owner",
              isAdmin: true,
              isEditor: true, 
            }),
          })
            .then((response) => response.json())
            .then(async (res) => {
              console.log(res);

              if (packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") {
              navigator.geolocation.getCurrentPosition(function(position) {
                console.log("Latitude is :", position.coords.latitude);
                console.log("Longitude is :", position.coords.longitude);

                fetch(GlobalApi + "/Inspection/save_inspector_loc", {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({inspection_id:res1.data.id,
                    latitude:position.coords.latitude,
                    longitude:position.coords.longitude}),
                })
                  .then((response) => response.json())
                  .then(async (data) => {
                    console.log(data)
                  });
              });}else{
                fetch(GlobalApi + "/Inspection/save_inspector_loc", {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({inspection_id:res1.data.id,
                    latitude:null,
                    longitude:null}),
                })
                  .then((response) => response.json())
                  .then(async (data) => {
                    console.log(data)
                  });
              }
              history.push("inspection-edit/" + res1.data.id + "/edit");
            });
        });
    } else {
      swal(t("Warning"), packageDetails.inspection_request_status, "warning");
    }
  }

  function handleStart(schedule_id, template_id) {
    console.log(schedule_id, template_id);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      schedule_id,
      template_id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/TemplateInspection/get_template_for_inspection?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          if (response.data) {
            createInspection(response.data);

            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            handleStart(schedule_id, template_id);
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  }

  const Template = _.filter(templates, {
    id: data.template_id,
  });
  // console.log(Template);
  const CreatedBy = _.filter(users, {
    id: data.created_by,
  });
  console.log(CreatedBy);
  const Listing = _.filter(users, {
    id: data.created_by,
  });

  console.log(packageDetails);

  if (packageDetails !== null) {
    return (
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            style={{ background: "#f5f5f5" }}
            onClose={handleClose}
          >
            {data.title}
          </DialogTitle>
          <div className="" style={{padding:20}}>
            <table class="details-table">
              <tbody>
                <tr>
                  <td className="custom-spacing">Schedule Window</td>
                  <td className="table-truncate">
                    <b>
                      Start at {moment(data.start_date).format("MMMM DD, YYYY")}
                      . Due by {moment(data.end_date).format("MMMM DD, YYYY")}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="custom-spacing">Template</td>
                  <td>
                    <b>{Template[0] ? Template[0].title : ""} </b>
                  </td>
                </tr>
                <tr>
                  <td className="custom-spacing">Assigned By</td>
                  <td>
                    <b>
                      {" "}
                      {data.user && data.user.first_name}{" "}
                      {data.user && data.user.last_name}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="custom-spacing">Assignees</td>
                  <td>
                    <div>
                      {data.ScheduleAssignees.map((v) => {
                        return (
                          <Tooltip
                            title={`${
                              v.User.identifier === "User"
                                ? v.User.first_name + " " + v.User.last_name
                                : v.User.group_name
                            } ${
                              v.User.identifier === "Group"
                                ? v.User.group_name
                                : ""
                            }`}
                            aria-label=""
                          >
                            <PersonPinIcon />
                          </Tooltip>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <DialogActions style={{ width: "100%",padding:10 }}>
            <Grid container direction="row" justify="center">
              <Grid item xs={8}>
                <Typography variant="h6" style={{color: "#043077",fontSize:16}}>
                {packageDetails?.inspection_count +
                  "/" +
                  (packageDetails.inspection_limit === "Unlimited"
                    ? "~"
                    : packageDetails.inspection_limit) +
                  " inspection have been created"}
                </Typography>
              </Grid>
              <Grid item xs={4} align="right">
                {(packageDetails?.inspection_limit !=
                "Unlimited" ? (
                  parseInt(packageDetails.inspection_limit) >
                  parseInt(packageDetails.inspection_count)
                ) : (
                  true
                )) ? (
                  <Button
                    // autoFocus
                    onClick={() => handleStart(data.id, data.template_id)}
                    style={{ background: "#043077", color: "white" }}
                  >
                    Start Inspection
                  </Button>
                ) : (
                  <Button
                    // autoFocus
                    onClick={() => {
                      handleClose();

                      handlePackage("/update_package")
                    }}
                    style={{ background: "#043077", color: "white" }}
                  >
                    Upgrade package
                  </Button>
                )}
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return <Spinner/>;
  }
}
